import { useEffect, useRef } from "preact/hooks"

// Shared skeleton behind the "hold the just-answered question on screen for
// a bit, then move on" behaviour in SoloPlay and MatchPlay: a single pending
// timeout, replaced (never stacked) each time the returned function is
// called, and cleared whenever `resetKey` (the round/match id) changes or
// the component unmounts, so a stale timer from a previous round can never
// fire into a new one. The surrounding recovery flows (409 refetch, SSE
// resync) differ enough between the two callers that only this part is
// shared.
export function useRevealTimer(
	resetKey: unknown,
): (ms: number, fn: () => void) => void {
	const timeout = useRef<number | undefined>(undefined)

	useEffect(() => {
		return () => {
			if (timeout.current !== undefined) window.clearTimeout(timeout.current)
		}
	}, [resetKey])

	return (ms, fn) => {
		if (timeout.current !== undefined) window.clearTimeout(timeout.current)
		timeout.current = window.setTimeout(fn, ms)
	}
}
